import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'compiledTheme';

export const { resolve, reject, update, patterns } = createLifecycleFor(TYPE);
